export const keepsServiceScroll = (previousPath, nextPath) =>
    previousPath.startsWith('/leistungen') && nextPath.startsWith('/leistungen');
